import { render, staticRenderFns } from "./addActor.vue?vue&type=template&id=76f3ee6c&scoped=true&"
import script from "./addActor.vue?vue&type=script&lang=js&"
export * from "./addActor.vue?vue&type=script&lang=js&"
import style0 from "./addActor.vue?vue&type=style&index=0&id=76f3ee6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f3ee6c",
  null
  
)

export default component.exports